import { AppConfig, Content, Assets } from '../types';

// Hardcoded Bank Data
export const HARDCODED_BANKS = [
  {
    "id": "8048",
    "name": "JPMorgan Funds",
    "home_url": null,
    "login_url": null,
    "forgot_password_url": null,
    "signup_url": null,
    "supports_transaction_aggregation": null,
    "supports_account_verification": null,
    "supports_account_history": null,
    "supports_account_owner_info": null,
    "supports_student_loan_data": null,
    "supports_loan_payment_details": null,
    "account_type": null,
    "institution_type": null,
    "status": "online",
    "time_zone": null,
    "currency": "USD",
    "phone": "1-800-480-4111",
    "email": "funds.website.support@jpmorganfunds.com",
    "address": {
      "address_line1": null,
      "address_line2": null,
      "city": "Boston",
      "state": "MA",
      "postal_code": null,
      "country": "USA"
    },
    "oauthEnabled": false,
    "branding": {
      "logo": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/8048/logo.svg",
      "alternate_logo": null,
      "icon": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/8048/icon.svg",
      "primary_color": null,
      "tile": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/8048/tile.svg"
    },
    "special_instructions": null,
    "special_text": null
  },
  {
    "id": "170758",
    "name": "Bank of America",
    "home_url": null,
    "login_url": null,
    "forgot_password_url": null,
    "signup_url": null,
    "supports_transaction_aggregation": null,
    "supports_account_verification": null,
    "supports_account_history": null,
    "supports_account_owner_info": null,
    "supports_student_loan_data": null,
    "supports_loan_payment_details": null,
    "account_type": null,
    "institution_type": null,
    "status": "online",
    "time_zone": null,
    "currency": "USD",
    "phone": "1-800-792-0808",
    "email": "https://www.bankofamerica.com/contact/",
    "address": {
      "address_line1": null,
      "address_line2": null,
      "city": "Charlotte",
      "state": "NC",
      "postal_code": null,
      "country": "USA"
    },
    "oauthEnabled": true,
    "branding": {
      "logo": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170758/logo.svg",
      "alternate_logo": null,
      "icon": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170758/icon.svg",
      "primary_color": null,
      "tile": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170758/tile.svg"
    },
    "special_instructions": null,
    "special_text": null
  },
  {
    "id": "170718",
    "name": "Wells Fargo",
    "home_url": null,
    "login_url": null,
    "forgot_password_url": null,
    "signup_url": null,
    "supports_transaction_aggregation": null,
    "supports_account_verification": null,
    "supports_account_history": null,
    "supports_account_owner_info": null,
    "supports_student_loan_data": null,
    "supports_loan_payment_details": null,
    "account_type": null,
    "institution_type": null,
    "status": "online",
    "time_zone": null,
    "currency": "USD",
    "phone": "1-800-956-4442",
    "email": "https://www.wellsfargo.com/per/per_ask_us.jhtml",
    "address": {
      "address_line1": null,
      "address_line2": null,
      "city": "San Francisco",
      "state": "CA",
      "postal_code": null,
      "country": "USA"
    },
    "oauthEnabled": true,
    "branding": {
      "logo": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170718/logo.svg",
      "alternate_logo": null,
      "icon": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170718/icon.svg",
      "primary_color": null,
      "tile": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170718/tile.svg"
    },
    "special_instructions": null,
    "special_text": null
  },
  {
    "id": "170881",
    "name": "Citibank",
    "home_url": null,
    "login_url": null,
    "forgot_password_url": null,
    "signup_url": null,
    "supports_transaction_aggregation": null,
    "supports_account_verification": null,
    "supports_account_history": null,
    "supports_account_owner_info": null,
    "supports_student_loan_data": null,
    "supports_loan_payment_details": null,
    "account_type": null,
    "institution_type": null,
    "status": "online",
    "time_zone": null,
    "currency": "USD",
    "phone": "1-800-950-5114",
    "email": "https://online.citibank.com/US/Welcome.c",
    "address": {
      "address_line1": null,
      "address_line2": null,
      "city": "New York",
      "state": "NY",
      "postal_code": null,
      "country": "USA"
    },
    "oauthEnabled": true,
    "branding": {
      "logo": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/1003/logo.svg",
      "alternate_logo": null,
      "icon": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/1003/icon.svg",
      "primary_color": null,
      "tile": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/1003/tile.svg"
    },
    "special_instructions": null,
    "special_text": null
  },
  {
    "id": "170778",
    "name": "Capital One",
    "home_url": null,
    "login_url": null,
    "forgot_password_url": null,
    "signup_url": null,
    "supports_transaction_aggregation": null,
    "supports_account_verification": null,
    "supports_account_history": null,
    "supports_account_owner_info": null,
    "supports_student_loan_data": null,
    "supports_loan_payment_details": null,
    "account_type": null,
    "institution_type": null,
    "status": "online",
    "time_zone": null,
    "currency": "USD",
    "phone": "1-800-955-7070",
    "email": "mailto:webinfo@capitalone.com",
    "address": {
      "address_line1": null,
      "address_line2": null,
      "city": "Salt Lake City",
      "state": "UT",
      "postal_code": null,
      "country": "USA"
    },
    "oauthEnabled": true,
    "branding": {
      "logo": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170778/logo.svg",
      "alternate_logo": null,
      "icon": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170778/icon.svg",
      "primary_color": null,
      "tile": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170778/tile.svg"
    },
    "special_instructions": null,
    "special_text": null
  },
  {
    "id": "170894",
    "name": "US Bank",
    "home_url": null,
    "login_url": null,
    "forgot_password_url": null,
    "signup_url": null,
    "supports_transaction_aggregation": null,
    "supports_account_verification": null,
    "supports_account_history": null,
    "supports_account_owner_info": null,
    "supports_student_loan_data": null,
    "supports_loan_payment_details": null,
    "account_type": null,
    "institution_type": null,
    "status": "online",
    "time_zone": null,
    "currency": "USD",
    "phone": "1-800-685-5065",
    "email": "https://www2.usbank.com/cgi_w2/cfm/cust_service/form_questions.cfm",
    "address": {
      "address_line1": null,
      "address_line2": null,
      "city": "Minneapolis",
      "state": "MN",
      "postal_code": null,
      "country": "USA"
    },
    "oauthEnabled": true,
    "branding": {
      "logo": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170894/logo.svg",
      "alternate_logo": null,
      "icon": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170894/icon.svg",
      "primary_color": null,
      "tile": "https://prod-carpintero-branding.s3.us-west-2.amazonaws.com/170894/tile.svg"
    },
    "special_instructions": null,
    "special_text": null
  }
];

// App Constants
export const APP_CONFIG: AppConfig = {
    BRAND_NAME: 'dayli',
    COLORS: {
        PRIMARY_ORANGE: '#F65E18',
        PRIMARY_YELLOW: '#FBD049',
        ACCENT_YELLOW: '#FFC322',
        DARK_BROWN: '#3A190A',
        WHITE: '#FFFFFF',
        BLACK: '#000000'
    }
};

// Text Content
export const CONTENT: Content = {
    HERO: {
        MAIN_HEADING: 'Get 2% cashback on DoorDash and every merchant every time.',
        SUBHEADING: '100% Approval. No Credit Check.\nNo Fees. No Interest. Just Cashback.',
        CTA_TEXT: 'Get Dayli in 60s'
    },
    HOW_IT_WORKS: {
        TITLE: 'Here\'s how dayli works!',
        STEPS: [
            'Sign up in 60 seconds with your bank account. No Credit Check. No Fees. No Interest.',
            'Use it like any card online, in-store, anywhere.',
            'Get 2% Cashback on DoorDash or any other merchant.',
            'We debit your bank account three days later. No debt. No stress.',
            'We report to all three bureaus. Watch your score climb.'
        ],
        CTA_TEXT: 'Get Dayli in 60s'
    },
    FAQ: {
        TITLE: 'Still wondering how it works?',
        ITEMS: [
            {
                question: 'What are the benefits of using Dayli instead of my debit card?',
                answer: 'More secure - Dayli ensures that your underlying bank account is not fully exposed, whereas losing your debit card can expose your entire bank account.\n\n2% cashback on every transaction for life.\n\nIt improves your credit score.'
            },
            {
                question: 'What are the benefits of using Dayli instead of my credit card?',
                answer: 'With the Dayli Card, you get 10% cashback on Doordash and 1.5% cashback on all other transactions - no credit checks, no fees. We debit your account daily, so there\'s no debt and no interest.'
            },
            {
                question: 'How is Dayli different from a credit or debit card?',
                answer: 'Dayli is a unique charge card, linked to your bank account. Use it like any other card, earn rewards on every purchase, and get billed daily with auto-debits within 3 days.',
            },
            {
                question: 'Will applying for Dayli affect my credit score?',
                answer: 'No, applying for Dayli does not affect your credit score since we do not perform any credit checks. Instead, using Dayli instead of your debit card can improve your score each month3 since we report your payments to the bureau.',
            }
        ],
        CTA_TEXT: 'Get Dayli in 60s'
    },
    TESTIMONIALS: {
        TITLE: 'Don\'t just take our word for it',
        QUOTES: [
            'No fees, no interest, no catches. Just real rewards. Why was I ever using a regular debit card? – Jasmine K.',
            'Fastest sign-up ever. Took under a minute. And I love that they pull funds daily, no surprise bills. – Liam T.',
            'Signed up on my lunch break. By dinner, I was earning cash back on groceries. Zero stress. – Taylor R.',
            'I didn\'t think I\'d ever qualify for a credit builder card. Dayli made it instant, and fun. – Miguel A.',
            'Dayli gave me a fresh start. After just 2 months, my credit score jumped 42 points. – Devon M.'
        ]
    },
    FOOTER: {
        COMPANY_INFO: {
            COPYRIGHT: '© Ryze India Advisory Limited. All rights reserved.',
            CONTACT: 'Need help? Reach us at\nsupport@dayli.cards'
        },
        LINKS: {
            ABOUT: ['How it works', 'FAQs', 'Get Dayli in 60s'],
            LEGAL: ['Privacy Policy', 'Terms & Conditions']
        },
        DISCLAIMER: '¹The Aligned Company d/b/a Dayli ("Dayli") is a technology company, not a bank. The Dayli Card is issued by Evolve Bank & Trust or Patriot Bank N.A. (Member FDIC), pursuant to a license by Mastercard International. Line of credit provided by Lead Bank. This Card can be used everywhere Mastercard is accepted. Rewards points only available with rewards plan. Membership fees apply. Please refer to our Terms of Service and Cardholder Agreement for additional details. ²Increases or specific changes to your credit score are not guaranteed. Dayli is responsible for credit reporting and reports on time and late payments, which may impact a credit bureau\'s determination of your credit score either positively or negatively. Credit scores are independently determined by credit bureaus based on a number of factors, including your other financial transactions. Dayli reports to Experian® and Equifax®. Dayli and related services will not remove negative credit history from your credit report. ³To transact with your Dayli Card, you must have an active, Mastercard-compatible bank account linked to Dayli\'s services ("Partner Account"). If your Partner Account is disconnected from Dayli services for any reason, you will not be able to use your Dayli Card. Within 30 days of the date of each transaction made using your Dayli Card, Dayli will initiate one or more ACH s to deduct equivalent funds from your Partner Account. These ACH s typically deduct funds from your Partner Account within 2 to 3 business days after initiation by Dayli or 14 days after your transaction depending on repayment program selected. ⁴Data based on a 12-month study of active Dayli customers with good credit habits. Dayli cardholders with a credit score of 650 or less upon signing up, saw an average credit score increase of 48 points during the study. To learn more, please see the full study, performed by Brandata, at Dayli.app/study. Individual results may vary. While credit scores may increase for customers with good credit habits, they may also decrease for customers with poor credit behavior. ⁵Data from WalletHub This communication is for informational purposes only and should not be considered financial advice.'
    }
};

// Asset paths
export const ASSETS: Assets = {
    LOGO: '/assets/dayli-logo.svg',
    LOGO_WHITE: '/assets/dayli-logo-white.svg',
    CARD_LOGO_WHITE: '/assets/card-logo-white.svg',
    PROFILE_IMAGE: '/assets/profile.png',
    ARROW_DECORATION: '/assets/arrow-decoration.svg',
    FAQ_ARROW_DOWN: '/assets/faq-arrow-down.svg',
    FAQ_ARROW_UP: '/assets/faq-arrow-up.svg',
    FOOTER_BG_LOGO: '/assets/footer-bg-logo.svg',
    FOOTER_BG_ICON: '/assets/footer-bg-icon.svg'
}; 